export default {
  floatingTopMenu: {
    openSettings: 'Einstellungen',
    showAbout: 'Allgemeine Informationen',
    about: 'Über ORS',
    openrouteserviceAPI: 'Openrouteservice API',
    openrouteserviceForDisasters: 'ORS für Katastrophenmanagement',
    askOpenrouteservice: 'Openrouteservice fragen',
    settingsTooltip: 'Klicken Sie hier, um Einstellungen und weitere Optionen anzupassen',
    shadedRoutingLink:'https://heigit.org/auf-schattigem-weg-ans-ziel-hitzemeidende-routing-anwendung-fur-viele-deutsche-stadte-verfugbar',
    shadedRouting: 'Über beschattetes Routing'
  }
}
